import { render, staticRenderFns } from "./SetSuborderState.vue?vue&type=template&id=71c4dc33&"
import script from "./SetSuborderState.vue?vue&type=script&lang=js&"
export * from "./SetSuborderState.vue?vue&type=script&lang=js&"
import style0 from "./SetSuborderState.vue?vue&type=style&index=0&id=71c4dc33&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports